import { ColumnType } from "antd/es/table";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { updateMenuData } from "../../store/slices/misc/menuData";
import { useLocation, useNavigate } from "react-router-dom";
import { TooltipComponent } from "../../components/Component";
import Template1 from "./ReportTemplates/Template1";
import dayjs from "dayjs";

const TaskAgingReport = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const { id: projectId, projectName } = location.state || {};

  // Scroll to top when component mounts or when navigating to this page
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const columns: ColumnType<any>[] = [
    {
      title: "Task Name",
      dataIndex: "taskName",
      key: "taskName",
      width: 150,
      render(text: any, record: any) {
        return (
          <>
            <span
              className="inlineTableCellLink"
              id={`task-${record?.taskId}`}
              onClick={() => {
                console.log("Task Name Clicked:");
                navigate(`/pms/project/task-detail/${record.taskId}`, {
                  state: {
                    projectId,
                    projectName,
                    returnPath: location.pathname,
                    returnState: location.state,
                  },
                });
              }}
            >
              {text}
            </span>
            <TooltipComponent
              iconClass="info-circle text-info"
              icon={""}
              id={`task-${record?.taskId}`}
              direction="right"
              text={"Click To View " + text + " Details"}
              containerClassName={"mt-1"}
            />
          </>
        );
      },
    },
    {
      title: "Owner Name",
      dataIndex: "assignedToName",
      key: "assignedToName",
      width: 150,
      render: (text) => (text === null || text === undefined || text === "" ? "N/A" : text)
    },
    {
      title: "Assigned Date",
      dataIndex: "assignedDate",
      key: "assignedDate",
      width: 100,
      render: (text: string) => text || "N/A"
    },
    {
      title: "Days Open",
      dataIndex: "daysOpened",
      key: "daysOpened",
      width: 100,
      render: (text) => (text === null || text === undefined || text === "" ? "N/A" : `${text} Days`)
    },
    {
      title: "Status",
      dataIndex: "taskStatus",
      key: "taskStatus",
      width: 150,
      render: (text) => (text === null || text === undefined || text === "" ? "N/A" : text)
    },
  ];

  useEffect(() => {
    dispatch(
      updateMenuData([
        {
          text: "Task Asging Report",
          link: "pms/task-aging-report",
        },
      ])
    );
  }, []);

  return (
    <>
      <Template1
        moduleKey={window.location.pathname}
        columns={columns}
        pageTitle="Task Asging Report"
        pageDescription=""
        previousPath={{
          link: "/pms/project/reports",
          state: location.state,
        }}
        filters={{
          defaultFilters: {
            dateRange: {
              title: "Planned Start Date",
            },
          },
        }}
      />
    </>
  );
};

export default TaskAgingReport;
